document.addEventListener('DOMContentLoaded', () => {
    const pageLink = window.location.href;
    const isBoxBuilderPage = pageLink.includes('/flavour-box');
    if (isBoxBuilderPage) {
        document.body.classList.add('build-a-box-page');
    }
})